import React from "react";

export default function EmptyState({ message = "No data found" }) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <p className="text-gray-600">{message}</p>
    </div>
  );
}
